const SW_RELOAD_KEY = "wlj-sw-reloaded";

/**
 * A controlling service worker keeps serving this document until the next
 * load. Unregister it, then reload once so chunk requests are not intercepted.
 * Returns true when a reload was started and boot should stop.
 */
export async function cleanupLegacyServiceWorkers() {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
    return false;
  }

  let registrations = [];
  try {
    registrations = await Promise.race([
      navigator.serviceWorker.getRegistrations(),
      new Promise((resolve) => setTimeout(() => resolve([]), 1500)),
    ]);
  } catch (e) {
    return false;
  }

  const list = Array.isArray(registrations) ? registrations : [];
  if (!list.length && !navigator.serviceWorker.controller) return false;

  await Promise.all(list.map((registration) => registration.unregister().catch(() => {})));

  if (!navigator.serviceWorker.controller) return false;

  try {
    if (sessionStorage.getItem(SW_RELOAD_KEY)) return false;
    sessionStorage.setItem(SW_RELOAD_KEY, "1");
  } catch (e) {
    return false;
  }

  const url = new URL(window.location.href);
  url.searchParams.set("wlj_refresh", String(Date.now()));
  window.location.replace(url.toString());
  return true;
}
